/** Single source of truth for comms TanStack Query keys. */
export const commsKeys = {
  channels: (siteId: string) => ['comms', siteId, 'channels'] as const,
  members:  (siteId: string) => ['comms', siteId, 'members'] as const,
  history:  (siteId: string, channelId: string) =>
    ['comms', siteId, 'channels', channelId, 'history'] as const,
  receipts: (siteId: string, channelId: string, messageId: string) =>
    ['comms', siteId, 'receipts', channelId, messageId] as const,
};
